<template>
    <b-modal :visible="visible">
        <template #modal-header>
            <slot name="header"></slot>
        </template>
        <template #default>
            <div class="d-flex flex-column">
                <slot name="body"></slot>
            </div>
        </template>
        <template #modal-footer>
            <slot name="footer"></slot>
        </template>
    </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue";

export default {
    name: 'Modal',
    components: { BModal },
    props: {
        visible: {
            type: Boolean,
            default: false,
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep {
    .modal-content {
        padding: 48px 48px;
    }
    .modal-header {
        border-bottom: 0 !important;
    }
    .modal-footer {
        border-top: 0 !important;
    }
    .close-icon {
        width: 45px;
        height: 45px;
        min-width: 45px;
        background: #282828;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        font-weight: bold;
        cursor: pointer;
    }
}
</style>
